import React, { useEffect } from 'react'
import Sectionone from './sectionone'
import { SectionSecond } from './sectionsecond'
import axios from 'axios';
import { useDispatch } from 'react-redux';

const Home = () => {

  const dispatch = useDispatch();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

    if (token) {
      localStorage.setItem('token', token);
    }
  }, []);


  useEffect(() => {
    const fetchData = async () => {
      let token = localStorage.getItem("token");
      const reqoption = {
        headers: {
          Authorization: `Token ${token}`,
        },
      };

      try {
        const response = await axios.get('https://api.edubridge.org.uk/api/notification', reqoption);
        const data = response.data.message;

        dispatch({ type: 'SET_NOTIFICATION_DATA', payload: data });

        if (Notification.permission === 'granted') {
          if (data && typeof data === 'string' && data.trim() !== '') {
            const notification = new Notification('Notification', {
              body: data,
              requireInteraction: true,
            });

            notification.onclick = () => {
              window.open('https://app.edubridge.org.uk/quizgenerator');
            };

            notification.onclose = () => {
            };
          }
        } else if (Notification.permission !== 'denied') {
          Notification.requestPermission().then(permission => {
            if (permission === 'granted') {
              if (data && typeof data === 'string' && data.trim() !== '') {
                const notification = new Notification('Notification', {
                  body: data,
                  requireInteraction: true,
                });

                notification.onclick = () => {
                  window.open('https://app.edubridge.org.uk/quizgenerator');
                };
                notification.onclose = () => {
                };
              }
            }
          });
        }
      } catch (error) {
        console.error('Failed to fetch data:', error);
      }
    };

    fetchData();
  }, [dispatch]);
  return (
    <>
      <Sectionone />
      <SectionSecond />
    </>
  )
}

export default Home